import {DomainError} from '@s-ui/domain'

export class AddComparatorAdsError extends DomainError {
  #cause
  #code
  #message

  static GENERIC_ERROR_CODE = 'add_comparator_ads_error'
  static INVALID_AD_ERROR_CODE = 'invalid_ad_add_comparator_ads_error'
  static MAX_ADS_LIMIT_REACHED_ERROR_CODE = 'max_ads_limit_reached_add_comparator_ads_error'

  constructor({cause, code, message}) {
    super({cause, code, message})
    this.#cause = cause
    this.#code = code
    this.#message = message
  }

  static isAddComparatorAdsError({error}) {
    return error instanceof AddComparatorAdsError
  }

  static create({code, message, cause}) {
    return new AddComparatorAdsError({code, message, cause})
  }

  static createGenericError({cause}) {
    return AddComparatorAdsError.create({
      code: AddComparatorAdsError.GENERIC_ERROR_CODE,
      cause
    })
  }

  static createMaxAdsLimitReached() {
    return AddComparatorAdsError.create({
      code: AddComparatorAdsError.MAX_ADS_LIMIT_REACHED_ERROR_CODE,
      message: 'Max ads limit reached'
    })
  }

  static createInvalidAdError({cause}) {
    return AddComparatorAdsError.create({
      code: AddComparatorAdsError.INVALID_AD_ERROR_CODE,
      message: 'Invalid ad',
      cause
    })
  }

  isMaxAdsLimitReachedError() {
    return this.#code === AddComparatorAdsError.MAX_ADS_LIMIT_REACHED_ERROR_CODE
  }

  isInvalidAdError() {
    return this.#code === AddComparatorAdsError.INVALID_AD_ERROR_CODE
  }

  get value() {
    return {
      code: this.#code,
      message: this.message,
      cause: this.cause
    }
  }

  toJSON() {
    return {
      code: this.#code,
      message: this.#message,
      cause: this.#cause
    }
  }
}
